import React, { useState, useEffect } from 'react';
import { getBrandingForDomain, loadPlatformBrandings } from '../../utils/PlatformBranding';
import { truncate } from '../../utils/StringUtils';
import './LinkCard.css';
import GateModal from '../GateModal/GateModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpinnerCircular } from 'spinners-react';

function LinkCard({ link }) {
  const gates = link.gates
  const url = link.url
  const title = link.title ? link.title : truncate(link.url)
  const startDate = link.startDate
  const endDate = link.endDate

  const [modalOpen, setModalOpen] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [brandingsLoaded, setBrandingsLoaded] = useState(false);
  const [dateRangeOk, setDateRangeOk] = useState(true);

  useEffect(() => {
    if (startDate && new Date(startDate) > new Date()) { setDateRangeOk(false) }
    if (endDate && new Date(endDate) < new Date()) { setDateRangeOk(false) }

    loadPlatformBrandings().then(() => setBrandingsLoaded(true));
  }, [startDate, endDate]);

  const handleGateClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCompleteGate = (index) => {
    setCompletedSteps((prevSteps) => {
      const newSteps = [...prevSteps, index];
      return newSteps;
    });
  };

  const handleOpenURL = () => {
    window.open(url, '_blank');
  };

  return (
    <>
      {dateRangeOk ?
        brandingsLoaded ? (
          <div className='link-card' >
            {gates && gates.length > 0 && (
              <div>
                <button onClick={handleGateClick} className="link-button" style={{ backgroundColor: getBrandingForDomain(url).color }}>
                  <FontAwesomeIcon icon={[getBrandingForDomain(url).pack, getBrandingForDomain(url).icon]} />
                  <span>{title}</span>
                </button>
                <GateModal
                  isOpen={modalOpen}
                  handleClose={handleCloseModal}
                  gates={gates}
                  onCompleteGate={handleCompleteGate}
                  completedSteps={completedSteps}
                  url={url}
                  title={title}
                />
              </div>
            )}
            {(!gates || gates.length === 0) && (
              <div>
                <button onClick={handleOpenURL} className="link-button" style={{ backgroundColor: getBrandingForDomain(url).color }}>
                  <FontAwesomeIcon icon={[getBrandingForDomain(url).pack, getBrandingForDomain(url).icon]} />
                  <span>{title}</span>
                </button>
              </div>
            )}
          </div >
        ) : (
          <div className="loading">
            <SpinnerCircular color='white' />
          </div>
        )

        : ("")}
    </>
  );
}

export default LinkCard;